enum ActionTypes {
  GET_FOLDERS = '@media-database/GET_FOLDERS',
  GET_FILES = '@media-database/GET_FILES',
  SET_ACTIVE_FOLDER = '@media-database/SET_ACTIVE_FOLDER',
  SET_UPLOAD = '@media-database/SET_UPLOAD',
  SET_IS_LOADING = '@media-database/SET_IS_LOADING',
}

export default ActionTypes
